import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { take } from 'rxjs';
import { SmallNumberPipe } from 'src/app/pipes/small-number/small-number.pipe';
import { AuthService } from 'src/app/services/auth-service/auth-service.service';
import { TopItemsService } from 'src/app/services/top-items/top-items.service';
import { GalleryComponent, GalleryImage } from 'src/app/shared/components/gallery/gallery.component';
import { AfmStats } from 'src/app/shared/models/top-items.model';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [CommonModule, RouterModule, MatIconModule, MatButtonModule, MatExpansionModule, MatCardModule, SmallNumberPipe, NgOptimizedImage, GalleryComponent],
})
export class HomeComponent {
  craftImages: GalleryImage[] = [
    new GalleryImage('assets/img/gallery/home/craft1.webp', 1603, 728, 'Craft 1 preview'),
    new GalleryImage('assets/img/gallery/home/craft2.webp', 2275, 1103, 'Craft 2 preview'),
    new GalleryImage('assets/img/gallery/home/craft3.webp', 1842, 1059, 'Craft 3 preview'),
    new GalleryImage('assets/img/gallery/home/craft4.webp', 2266, 875, 'Craft 4 preview'),
    new GalleryImage('assets/img/gallery/home/craft5.webp', 1525, 430, 'Craft 5 preview'),
    new GalleryImage('assets/img/gallery/home/craft6.webp', 1497, 1150, 'Craft 6 preview'),
    new GalleryImage('assets/img/gallery/home/craft7.webp', 1492, 1047, 'Craft 7 preview'),
  ];
  metaImages: GalleryImage[] = [new GalleryImage('assets/img/gallery/home/meta1.webp', 1727, 1084, 'Meta 1 preview')];
  topItemsImages: GalleryImage[] = [new GalleryImage('assets/img/gallery/home/topitems1.webp', 1724, 1185, 'Top Items 1 preview')];
  tradeCalculatorImages: GalleryImage[] = [
    new GalleryImage('assets/img/gallery/home/trade1.webp', 1867, 1207, 'Trade Calculator 1 preview'),
    new GalleryImage('assets/img/gallery/home/trade2.webp', 1223, 1182, 'Trade Calculator 2 preview'),
  ];
  farmCalculatorImages: GalleryImage[] = [
    new GalleryImage('assets/img/gallery/home/farm1.webp', 2498, 1194, 'Farm 1 preview'),
    new GalleryImage('assets/img/gallery/home/farm2.webp', 2493, 1232, 'Farm 2 preview'),
    new GalleryImage('assets/img/gallery/home/farm3.webp', 2501, 906, 'Farm 3 preview'),
    new GalleryImage('assets/img/gallery/home/farm4.webp', 1231, 1105, 'Farm 4 preview'),
  ];
  mapImages: GalleryImage[] = [
    new GalleryImage('assets/img/gallery/home/map1.webp', 964, 1224, 'Map 1 preview'),
    new GalleryImage('assets/img/gallery/home/map2.webp', 1137, 1220, 'Map 2 preview'),
    new GalleryImage('assets/img/gallery/home/map3.webp', 1134, 755, 'Map 3 preview'),
    new GalleryImage('assets/img/gallery/home/map4.webp', 1138, 592, 'Map 4 preview'),
    new GalleryImage('assets/img/gallery/home/map5.webp', 1136, 1219, 'Map 5 preview'),
  ];
  tradeRoutesImages: GalleryImage[] = [new GalleryImage('assets/img/gallery/home/traderoutes1.webp', 2659, 1224, 'Trade Routes 1 preview')];
  priceCheckImages: GalleryImage[] = [new GalleryImage('assets/img/gallery/home/price1.webp', 1697, 866, 'Price 1 preview'), new GalleryImage('assets/img/gallery/home/price2.webp', 510, 394, 'Price 2 preview')];
  flipperImages: GalleryImage[] = [
    new GalleryImage('assets/img/gallery/home/flipper7.webp', 1688, 774, 'Flipper 7 preview'),
    new GalleryImage('assets/img/gallery/home/flipper2.webp', 838, 528, 'Flipper 2 preview'),
    new GalleryImage('assets/img/gallery/home/flipper1.webp', 1883, 908, 'Flipper 1 preview'),
    new GalleryImage('assets/img/gallery/home/flipper3.webp', 546, 397, 'Flipper 3 preview'),
    new GalleryImage('assets/img/gallery/home/flipper4.webp', 708, 398, 'Flipper 4 preview'),
    new GalleryImage('assets/img/gallery/home/flipper5.webp', 1226, 792, 'Flipper 5 preview'),
    new GalleryImage('assets/img/gallery/home/flipper6.webp', 967, 463, 'Flipper 6 preview'),
  ];

  afmStats = signal<AfmStats | undefined>(undefined);
  testimonials = [
    {
      image: 'assets/img/testimonials/luggi.webp',
      text: '"I made 70 million Silver in about 2 weeks. The best part is flipping from Caerleon to the Black Market is always possible, no need to set up a group or plan ahead. Just scan the markets and start printing money."',
      name: 'Luggi',
      rating: 5,
    },
    {
      image: 'assets/img/testimonials/ben.webp',
      text: '"I started with just 1.67 million silver and in only 3 days I was already at 7.16 million! This tool is super easy to use and it has been great for helping me to understand the market better."',
      name: 'Ben',
      rating: 4.5,
    },
    {
      image: 'assets/img/testimonials/tye.webp',
      text: '"Every time I come back to Albion, I look for flipper tools, and this is the best I\'ve tried. It saves so much time setting up and checking for profits."',
      name: 'Tye',
      rating: 5,
    },
  ];
  constructor(
    public authService: AuthService,
    private router: Router,
    private topItemsService: TopItemsService
  ) {
    this.topItemsService
      .getAfmStats()
      .pipe(take(1))
      .subscribe((afmStats) => {
        this.afmStats.set(afmStats);
      });
  }

  getStar(rating: number, index: number): string {
    const roundedRating = Math.round(rating * 2) / 2;
    if (index < Math.floor(roundedRating)) {
      return 'star';
    }
    if (index < roundedRating) {
      return 'star_half';
    }
    return 'star_border';
  }

  openLink(link: string) {
    window.open(link, '_blank');
  }
  openSupportLink() {
    this.router.navigate(['/support-us']);
  }
}
